import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedstate from 'vuex-persistedstate'
import SecureLs from 'secure-ls'
import { vuexfireMutations } from 'vuexfire'

import administrativeUnitModule from '@/store/modules/AdministrativeUnitModule'
import authModule from '@/store/modules/AuthModule'
import roleModule from '@/store/modules/RoleModule'
import permissionModule from '@/store/modules/PermissionModule'
import userModule from '@/store/modules/UserModule'
import UIModule from '@/store/modules/UIModule'
import fiscalPeriodsModule from '@/store/modules/FiscalPeriodsModule'
import historyModule from '@/store/modules/HistoryModule'
import fuenteFinanciamientoModule from '@/store/modules/FuenteFinanciamientoModule'
import fuenteFinanciamientoCapituloModule from '@/store/modules/FuenteFinanciamientoCapituloModule'
import planeacionModule from '@/store/modules/PlaneacionModule'
import prestacionesModule from '@/store/modules/PrestacionesModule'
import clavesPresupuestalesModule from '@/store/modules/ClavesPresupuestalesModule'
import proyectoModule from '@/store/modules/ProyectoModule'
import matrizUnidadesAdministrativasModule from '@/store/modules/MatrizUnidadesAdministrativasModule'
import partidaModule from '@/store/modules/PartidaModule'
import momentoModule from '@/store/modules/MomentoContableModule'
import presupuestoFederalModule from '@/store/modules/PresupuestoFederalModule'
import recursoFederalModule from '@/store/modules/RecursoFederalModule'
import ampliacionReduccionModule from '@/store/modules/AmpliacionReduccionModule'
import exportacionSAACGNETModule from '@/store/modules/ExportacionSAACGNETModule'
import momentosContablesModule from '@/store/modules/MomentosContablesModule'
import suficienciaPresupuestalModule from '@/store/modules/SuficienciaPresupuestalModule'
import polizasRHModule from '@/store/modules/polizas/PolizasRHModule'
import polizasSAModule from '@/store/modules/polizas/PolizasSAModule'
import polizasSGModule from '@/store/modules/polizas/PolizasSGModule'
import polizasRMSModule from '@/store/modules/polizas/PolizasRMSModule'
import polizasFModule from '@/store/modules/polizas/PolizasFModule'
import polizasAModule from '@/store/modules/polizas/PolizasAModule'
import polizasIEModule from '@/store/modules/polizas/PolizasIEModule'
import polizasModule from '@/store/modules/polizas/PolizasModule'
import cuentaContableModule from '@/store/modules/CuentaContableModule'
import capitulosModule from '@/store/modules/CapitulosModule'
import clavesCuentasModule from '@/store/modules/ClavesCuentasModule'
import tipoGastoModule from '@/store/modules/TipoGastoModule'
import traspasoModule from '@/store/modules/TraspasoModule'
import saldoModule from '@/store/modules/SaldoModule'
import reporteEstadoPptoEgresosModule from '@/store/modules/reportes/ReporteEstadoPptoEgresosModule'
import reporteAnaliticoPptoEgresosModule from '@/store/modules/reportes/ReporteAnaliticoPptoEgresosModule'
import reporteAuxiliarCuentasModule from '@/store/modules/reportes/ReporteAuxiliarCuentasModule'
import reporteSaldosPartidasModule from '@/store/modules/reportes/ReporteSaldosPartidasModule'
import reportePlaneacionSaldosPartidasModule from '@/store/modules/reportes/ReportePlaneacionSaldosPartidasModule'
import importAnaliticoEgresosUnidadAdministrativaModule from '@/store/modules/imports/ImportAnaliticoEgresosUnidadAdministrativaModule'

const ls = new SecureLs({ isCompression: false })

Vue.use(Vuex)

const persistedstate = createPersistedstate({
  //
  // Pertiste en local storage los siguientes estados
  paths: [
    'userModule.authUser',
    'userModule.cloneAuthUser',
    'userModule.viewAsUser',
    //
    //
    'planeacionModule.proyeccion.processed',
    'planeacionModule.analisis.processed',
    //
    //
    'presupuestoFederalModule.selected',
    'presupuestoFederalModule.importacion.processed',
    'presupuestoFederalModule.edicion.processed',
    //
    //
    'ampliacionReduccionModule.selected',
    'ampliacionReduccionModule.fuente_financiamiento',
    'ampliacionReduccionModule.importacion.processed',
    'ampliacionReduccionModule.edicion.processed'
  ]
})

//
// El almacenamiento de información por razones de seguridad
// es encriptado, esto se hace automáticamente para los estados
// que se han establecido en el path perseverar.
if (process.env.NODE_ENV === 'production') {
  persistedstate.storage = {
    getItem: key => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: key => ls.remove(key)
  }
}

export default new Vuex.Store({
  state: {},
  mutations: {
    ...vuexfireMutations
  },
  actions: {},
  modules: {
    prestacionesModule,
    UIModule,
    authModule,
    userModule,
    roleModule,
    permissionModule,
    administrativeUnitModule,
    fiscalPeriodsModule,
    historyModule,
    fuenteFinanciamientoModule,
    fuenteFinanciamientoCapituloModule,
    planeacionModule,
    clavesPresupuestalesModule,
    proyectoModule,
    matrizUnidadesAdministrativasModule,
    partidaModule,
    momentoModule,
    presupuestoFederalModule,
    recursoFederalModule,
    ampliacionReduccionModule,
    exportacionSAACGNETModule,
    momentosContablesModule,
    suficienciaPresupuestalModule,
    polizasRHModule,
    polizasSAModule,
    polizasSGModule,
    polizasRMSModule,
    polizasFModule,
    polizasAModule,
    polizasIEModule,
    polizasModule,
    cuentaContableModule,
    capitulosModule,
    clavesCuentasModule,
    tipoGastoModule,
    traspasoModule,
    saldoModule,
    reporteEstadoPptoEgresosModule,
    reporteAnaliticoPptoEgresosModule,
    reporteAuxiliarCuentasModule,
    reporteSaldosPartidasModule,
    reportePlaneacionSaldosPartidasModule,
    // Imports
    importAnaliticoEgresosUnidadAdministrativaModule
  },
  plugins: [persistedstate]
})
